import { useQuery } from "@tanstack/react-query";

import { useGraphqlClientWithoutAuth } from "~/lib/client/hooks/useGraphqlClient";
import {
  ExamSignupContext,
  normalizeExamSlug,
} from "~/lib/client/signupExamContext";

export function useSignupExamContext(
  rawSlug: string | string[] | undefined,
  routerReady: boolean
) {
  const client = useGraphqlClientWithoutAuth();
  const requested = routerReady && rawSlug !== undefined;
  const examSlug = normalizeExamSlug(rawSlug);

  const query = useQuery<ExamSignupContext | null>({
    queryKey: ["signupExamContext", examSlug],
    queryFn: async () => {
      if (!client || !examSlug) return null;
      const result = await client.SignupExamContext({ slug: examSlug });
      return result.signupExamContext ?? null;
    },
    enabled: routerReady && !!client && !!examSlug,
    retry: 1,
    staleTime: 5 * 60 * 1000,
  });

  return {
    context: query.data ?? null,
    examSlug,
    requested,
    isLoading: requested && !!examSlug && (!client || query.isPending),
    isError: query.isError,
  };
}
